import { Outlet } from 'react-router-dom';
import styles from './Layout.module.css';
import MainAppBar from './MainAppBar'; // Importer le MainAppBar

const Layout = () => {
    return (
        <div className={styles.layoutContainerWithAppBar}>
            <MainAppBar /> {/* Utiliser MainAppBar ici */}
            <main className={styles.mainContent}>
                <Outlet /> {/* C'est ici que le contenu des routes enfants sera rendu */}
            </main>
            <footer className={styles.footer}>
                <p>&copy; {new Date().getFullYear()} DigitalCloud360. Tous droits réservés.</p>
            </footer>
        </div>
    );
};

export default Layout;
